import * as z from 'zod';

import { BorrowerId, PortalUserId, RepayAccountId } from '../BrandedIds';
import { Actor } from '../events';
import { zodBrandedUuid } from '../utils/Zod';

export const AutopaySettingsBase = z.object({
  actor: Actor.optional(), // Owner of the autopay settings and used to figure out who can make subsequent changes
});

export const DwollaAutopaySettings = AutopaySettingsBase.extend({
  type: z.literal('dwolla'),
  bankUrl: z.string(),
  portalUserId: zodBrandedUuid<PortalUserId>(), // Deprecate this field
});
export type DwollaAutopaySettings = z.infer<typeof DwollaAutopaySettings>;

export const UsioAutopaySettings = AutopaySettingsBase.extend({
  type: z.literal('usio'),
  confirmationId: z.string(),
  borrowerId: zodBrandedUuid<BorrowerId>(),
  dayOfTheMonth: z.number().int().gt(0).lte(15).optional(),
});
export type UsioAutopaySettings = z.infer<typeof UsioAutopaySettings>;

export const RepayAutopaySettings = AutopaySettingsBase.extend({
  type: z.literal('repay'),
  accountId: zodBrandedUuid<RepayAccountId>(),
  borrowerId: zodBrandedUuid<BorrowerId>(),
  dayOfTheMonth: z.number().int().gt(0).lte(15),
});
export type RepayAutopaySettings = z.infer<typeof RepayAutopaySettings>;

export const AutopaySettings = z.discriminatedUnion('type', [
  DwollaAutopaySettings,
  UsioAutopaySettings,
  RepayAutopaySettings,
]);
export type AutopaySettings = z.infer<typeof AutopaySettings>;
